// SIP / Investment Calculator Tool — SIP, lump-sum, FD and compound interest.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";
import { CALCULATORS } from "./lib/calculators";

export const sipCalculatorTool: Tool = {
  id: "sip-calculator",
  name: () => m.sip_tool_name(),
  description: () => m.sip_tool_description(),
  icon: "📊",
  basePath: "/sip-calculator",
  status: "stable",
  tags: ["finance", "investment", "sip", "calculator"],
  pages: [
    {
      name: () => m.sip_nav_main(),
      path: "/sip-calculator",
      description: () => m.sip_nav_main_desc(),
      icon: "📊",
    },
    {
      name: () => CALCULATORS["lump-sum-calculator"].navName(),
      path: "/sip-calculator/lump-sum-calculator",
      description: () => m.sip_nav_calc_desc(),
      icon: "💰",
    },
    {
      name: () => CALCULATORS["fd-calculator"].navName(),
      path: "/sip-calculator/fd-calculator",
      description: () => m.sip_nav_calc_desc(),
      icon: "🏦",
    },
    {
      name: () => CALCULATORS["compound-interest-calculator"].navName(),
      path: "/sip-calculator/compound-interest-calculator",
      description: () => m.sip_nav_calc_desc(),
      icon: "📈",
    },
  ],
};
